

import { ref } from "vue";
import { defineComponent } from 'vue';
import moment from 'moment';

export default defineComponent({
  name: "pedidos-localizacao-table",
  components: {

  },
    props: {
      pedidos: {
        type: Array,
        default: () => {
          [];
        },
      },
      searchCall: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      doRemovePedido: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      map: {
        type: Object,
        default: () => {
          return {}; // Retorna um objeto vazio como valor padrão
        },
      },
      filtro: {
        type: Object,
        default: () => {
          return {}; // Retorna um objeto vazio como valor padrão
        },
      },
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        sortKey: '', // Chave de ordenação
        sortAsc: true, // Direção da ordenação
        searchItem: false,
        searchIKey: '',
        searchQuery:''
      }
    },
    computed: {
      sortedData(){
        return this.pedidos.slice().sort((a:any, b:any) => {
          if (this.sortKey) {
            const keyA = a[this.sortKey];
            const keyB = b[this.sortKey];
            if (this.sortAsc) {
              return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
            } else {
              return keyA > keyB ? -1 : keyA < keyB ? 1 : 0;
            }
          }
          return 0;
        });
      },
    },
    methods: {

      gotoPedido(pedido:any){
        this.$router.push(`/pedidos/${pedido.id_pedido}`);
      },

      iconSort(key:any){
        if(this.sortKey!=key)return ""
        return `<i  class="fas fa-arrow-${this.sortAsc ? 'fas fa-arrow-up' : 'fas fa-arrow-down'}"></i>`

      },
      searchData(key:any) {
        if (this.searchIKey === key) {
          this.searchItem = !this.searchItem; // Alterna a direção da ordenação
        } else {
          this.searchIKey = key;
          this.searchItem = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },  
      sortData(key:any) {
        if (this.sortKey === key) {
          this.sortAsc = !this.sortAsc; // Alterna a direção da ordenação
        } else {
          this.sortKey = key;
          this.sortAsc = true; // Se mudar a chave, a ordenação será ascendente por padrão
        }
      },

    },
    setup(props:any) {
  
      let lastpedido:any = null;

      const searchCall = (field:any, termo:any) => {
        props.searchCall(field, termo); // Define o novo cen tro do mapa
      };
 

      const fDate = (date:any) => {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }

      const setCenterItem = (pedido: any) => {
        
        if(lastpedido != null){

          lastpedido.marker.setIcon('https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png');

        }

        pedido.marker.setIcon('https://maps.google.com/mapfiles/ms/icons/green-dot.png');

        lastpedido = pedido;

        if (pedido.latitude && pedido.longitude) {

          const newLocation = {
            lat: parseFloat(pedido.latitude),
            lng: parseFloat(pedido.longitude),
          };

          if (props.map && typeof props.map.setCenter === 'function') {
            props.map.setCenter(newLocation); // Define o novo cen tro do mapa
          } else {
            console.error("Mapa inválido ou setCenter não é uma função");
          }
        } else {
          console.error("Coordenadas inválidas ou não fornecidas");
        }


      };
      const removePedido = (pedido:any, id_embalagem:any) => {
        props.doRemovePedido(pedido, id_embalagem); // Define o novo cen tro do mapa
      }
      
      // Retorna os métodos ou variáveis que você quer expor
      return {
        searchCall,
        fDate,
        setCenterItem,
        removePedido
      };
    },

});
